import { verifyCode, VerifyCodePayload } from "@/api/forgot-password";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";
import { VerifyCodeResponse } from "./schema";

export const useVerifyCode = (
	options?: MutationOptionsWithoutFn<VerifyCodeResponse, VerifyCodePayload>,
) => {
	return useMutation({
		mutationFn: verifyCode,
		...options,
	});
};
